<template>
  <div>
    <div
      class="h-100 lh-1 vg-td-inner"
      :style="'width: '+50+'px;text-align:center;cursor:pointer;overflow:hidden;'"
    >
      <v-checkbox
        :ripple="false"
        class="restrict_size"
        @change="(e)=>{$emit('change')}"
        :value="state"
      ></v-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selected: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      state: false
    };
  },
  watch: {
    selected(vnew, vold) {
      this.state = vnew;
    }
  }
};
</script>
<style>
a .restrict_size {
  width: 25px;
  height: 25px;
  padding: 0px;
  margin: 0px;
  display: inline-block;
  margin-left: -12px;
  margin-top: -3px;
}
</style>
